module Meevo.Components.Logging {
    export enum LogLevel {
        All,
        Trace,
        Debug,
        Info,
        Warn,
        Error,
        Fatal,
        Off
    }
}